import { render } from "./headerCom2.vue?vue&type=template&id=ea5965b2&scoped=true"
const script = {}

import "./headerCom2.vue?vue&type=style&index=0&id=ea5965b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea5965b2"]])

export default __exports__